import { useState, useEffect, useImperativeHandle, forwardRef } from 'react'
import './styles.css'

const ChartSettings = forwardRef(({ chartType, onChartTypeChange }, ref) => {
  const [tempChartType, setTempChartType] = useState(chartType)

  useEffect(() => {
    setTempChartType(chartType)
  }, [chartType])

  useImperativeHandle(ref, () => ({
    apply: () => {
      onChartTypeChange(tempChartType)
    }
  }))

  return (
    <div className="chart-settings">
      <label className="chart-settings-label">Tipo de Gráfico</label>
      <div className="chart-settings-options">
        <label className="radio-option">
          <input
            type="radio"
            name="chartType"
            value="lineal"
            checked={tempChartType === 'lineal'}
            onChange={(e) => setTempChartType(e.target.value)}
          />
          <span className="radio-label">Lineal</span>
        </label>
        <label className="radio-option">
          <input
            type="radio"
            name="chartType"
            value="barras"
            checked={tempChartType === 'barras'}
            onChange={(e) => setTempChartType(e.target.value)}
          />
          <span className="radio-label">Barras</span>
        </label>
      </div>
    </div>
  )
})

ChartSettings.displayName = 'ChartSettings'

export default ChartSettings
